import { createAISuggestTitleFromTitleToolbarPluginKey } from './ai-suggest-title-from-title-toolbar-plugin-key';
import { SafePlugin } from '../local-safe-plugin';
import { createOpenAIModalCommand } from '../decoration/actions';
import { suggestConfigItemForConfluenceTitleToolbar } from '../../prebuilt/config-items-range/suggest/suggest';
import { SuggestTitleEvents } from '../../utils/confluence-suggest-title/event-enums';
/**
 * EXPERIMENTAL: Plugin for experimental flow where 'Suggest title' in
 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
 * This plugin sets up the native event listeners required to react to suggest title triggers.
 */
export const createAISuggestTitleFromTitleToolbarPlugin = options => {
  const {
    aiGlobalOptIn
  } = options;
  return new SafePlugin({
    key: createAISuggestTitleFromTitleToolbarPluginKey,
    view: editorView => {
      let currentEditorView = editorView;
      const handleConfluenceTitleToolbarSuggestTitleClick = _event => {
        const {
          state,
          dispatch
        } = currentEditorView;
        const openAIModalCommand = createOpenAIModalCommand({
          state,
          configItem: suggestConfigItemForConfluenceTitleToolbar,
          lastTriggeredFrom: 'confluenceTitleToolbar',
          aiGlobalOptIn
        });
        openAIModalCommand(state, dispatch);
        return false;
      };

      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      document.addEventListener(SuggestTitleEvents.GenerateSuggestedTitle, handleConfluenceTitleToolbarSuggestTitleClick);
      return {
        update: newEditorView => {
          currentEditorView = newEditorView;
        },
        destroy: () => {
          // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
          document.removeEventListener(SuggestTitleEvents.GenerateSuggestedTitle, handleConfluenceTitleToolbarSuggestTitleClick);
        }
      };
    }
  });
};